<template>
  <lego-modal-extend-v2
    ref="modal"
    :title="$t('title.performanceCompare')"
    :custom-style="customStyle"
    @closed="onClosed"
  >
    <div class="container-performace-compare">
      <monitoring-target-common
        :productCodes="searchCodes.productTypeCodes"
        :productTypeGroups="searchCodes.productTypeGroups"
        :subProductCodes="searchCodes.subTypeCodes"
        :defaultProductCode="searchModel.productTypeCode"
        :defaultSubProductCode="searchModel.subTypeCode"
        :resetTarget="isResetTarget"
        :selectedItems="listChips"
        :isDisabledBtn="!isAuthStatus"
        @change-product-type-code="onChangeProductTypeCode"
        @change-sub-type-code="onChangeSubTypeCode"
        @open-drop-down="showAddTargetDialog"
        @confirm-dialog="confirmDialog"
        @remove="removeTarget"
        @close-dialog="closeDialog"
      >
        <AddMonitorTargetDialog
          v-if="isCheckLoadData"
          :monitorInfo="popup.addMonitorProps"
          :searchDate="searchDate"
          @selected-items="chooseItems"
          :selected="selectedTargets"
        />
      </monitoring-target-common>

      <scpm-divider style="margin: 0 0 24px 0" />

      <div class="container-comp">
        <div class="container-comp__left">
          <performance-item
            :metricList="metricList"
            :selectedMetrics="selectedMetrics"
            showTitle
            type="checkbox"
            @on-selected-metric="onSelectedMetric"
            :mutateInput="$util.replaceFilterTextAndeWhitespace"
          />
        </div>

        <!-- 성능항목 -->
        <div class="container-comp__right">
          <!-- 성능항목 목록 -->
          <div class="container-comp__right-filter">
            <lego-segment-wrapper class="view-mode" v-model="dashboardType">
              <lego-segment-button value="detail">
                <sc-icon
                  name="ri-list-view-new"
                  :style="dashboardType == 'detail' ? 'color: #2C59D9' : 'color: #868D9C'"
                  :size="16"
                  v-lego-tooltip="$t('button.detail')"
                />
              </lego-segment-button>
              <lego-segment-button value="summary">
                <sc-icon
                  name="ri-grid_view_new"
                  :style="dashboardType == 'summary' ? 'color: #2C59D9' : 'color: #868D9C'"
                  :size="16"
                  v-lego-tooltip="$t('button.summary')"
                />
              </lego-segment-button>
              <div v-if="isCDN && isNotChangeProduct" class="chart-guide">
                <lego-icon
                  iconType="line"
                  icon="information"
                  :size="20"
                  style="vertical-align: middle; margin-top: -1px"
                />
                {{ $t('label.cdnGuide') }}
              </div>
            </lego-segment-wrapper>
            <ScpmReloadDatePicker
              ref="reloadPicker"
              @refresh="onRefresh"
              @save="onRefresh"
              :defaultValue="defaultInquiryPeriod"
              refreshPlay
              isPerformance
              isMonitoringPerformance
            />
          </div>

          <div class="container-comp__right-graph" ref="contentChart">
            <!-- chart list -->
            <c-scroll v-if="selectedMetrics.length" ref="cscroll" style="padding-right: 14px">
              <KeepAlive>
                <div>
                  <lego-dashboard v-show="isSummary" :col="4" :row="1" :gap="12" :vsize="194">
                    <lego-dashboard-item
                      v-for="(item, idx) in selectedMetrics"
                      v-slot:default="{}"
                      :x="parseInt(idx % 4)"
                      :y="parseInt(idx / 4)"
                      :key="item.metricKey"
                      :widthContent="1168"
                      :ref="`chart_${item.metricKey}`"
                    >
                      <SummaryChart
                        class="summary-chart-item"
                        parentClass="container-comp__right-graph"
                        :summaryData="dataSummaryChart[item.metricKey]"
                        :selectedMetric="item"
                        :selectedTargets="selectedTargets"
                        :productType="searchModel.productTypeCode"
                        :productSubType="searchModel.subTypeCode"
                        :inquiryTime="[dateOption.startDate, dateOption.endDate]"
                        :options="getSummaryOptions(item)"
                        :collInterval="collInterval"
                        :showTooltipOfChart="showTooltipOfChart"
                        :isNow="dateOption.isNow"
                      />
                    </lego-dashboard-item>
                  </lego-dashboard>
                  <div
                    v-for="(item, idx) in selectedMetrics"
                    :key="item.metricKey"
                    :style="{
                      visibility: isSummary ? 'hidden' : 'visible',
                      height: isSummary ? 0 : 'max-content',
                      overflow: isSummary ? 'hidden' : 'initial'
                    }"
                  >
                    <InsightChart
                      :title="item.metricName"
                      :indivItemOptions="listIndividuals[item.metricKey]"
                      :key="dataInsightChart[item.metricKey]?.chartKey"
                      :collInterval="collInterval"
                      :closeAble="true"
                      :inquiryTime="[dateOption.startDate, dateOption.endDate]"
                      :data="dataInsightChart[item.metricKey]?.dataProps"
                      :paramDownloadChart="getParamDownloadChart(item)"
                      :options="getSummaryOptions(item)"
                      :showTooltipOfChart="showTooltipOfChart"
                      :isNow="dateOption.isNow"
                      @on-change="(event) => onChangeOfInsightChart(event, item)"
                      @on-zoom="onZoomChart"
                      @on-close="() => delMetricItem(idx)"
                      @add-widget="(chartType) => addWidgetPopup(item, chartType)"
                      @add-event-policy="() => eventAddModal(item)"
                    />
                  </div>
                </div>
              </KeepAlive>
            </c-scroll>
            <no-data
              :message="t('title.pleaseSelectPerformanceItem')"
              v-if="!selectedMetrics.length"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 닫기 버튼 -->
    <AddMonitorTargetPopup
      v-if="popup.addTargetShow"
      :monitorInfo="popup.addMonitorProps"
      @close="togglePopup('addTargetShow')"
      @confirm="addTarget"
    />
    <AddWidgetPopup
      v-if="popup.addWidget"
      :searchDate="searchDate"
      mode="externalAdd"
      :config="widgetConfig"
      @close="togglePopup('addWidget')"
      @widgetAdd="onWidgetAdd"
    />
    <EventAddModal
      v-if="popup.eventAddShow && selectedTargetAddSetting.metric"
      :product-type-code="searchModel.productTypeCode"
      :subProductCode="searchModel.subTypeCode"
      :selected-target="selectedTargetAddSetting"
      isPerformance
      @close="togglePopup('eventAddShow')"
      @confirm="togglePopup('eventAddShow')"
    />
  </lego-modal-extend-v2>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';

import AddWidgetPopup from '@/containers/widget/AddWidgetPopup.vue'; // 위젯 추가 팝업,
import widgetAddConfigMixin from '@/containers/widget/configs/widgetAddConfigMixin'; // 위젯 추가 공통 기능
import ScpmReloadDatePicker from '@/components/scpm/components/scpmReloadDatePicker/scpmReloadDatePicker';
import MonitoringTargetCommon from '@/containers/components/MonitoringTargetCommon.vue';
import LegoModalExtendV2 from '@/components/lego/extend/legoModalExtendV2.vue';
import AddMonitorTargetDialog from '@/containers/performance/AddMonitorTargetDialog.vue';
import PerformanceItem from '@/containers/components/performanceItem/index';
import NoData from '@/containers/components/performanceItem/NoData.vue';
import {
  SUB_OBJECT_TYPES_WITH_K8S,
  PRODUCT_SUB_TYPE_OBJECT_NAME
} from '@/containers/utils/constant';
import i18nMixin from '@/mixins/i18n.mixin';
import InsightChart from '@/containers/components/chart/InsightChart';
import SummaryChart from '@/containers/components/chart/SummaryChart';
import EventAddModal from '../event/eventSettings/EventAddModal.vue';
import AddMonitorTargetPopup from './AddMonitorTargetPopup.vue';
import legoEventBus from '@/lego-component/utils/eventBus/eventBus';
import { useProductTypeGroups } from '@/composables/useProductTypeGroups.js';
import { useCheckAuth } from '@/composables/useCheckAuthorization.js';
import { getDefaultMetricPayload } from '@/containers/components/chart/useChart.js';
import {
  convertRawDataToDataChart,
  checkIsCollectionValue,
  getParamChart
} from '@/containers/components/chart/utils.js';
import { scpmUtil } from '@/utils/scpmUtil';
import { useChart } from '@/composables/useChart.js';
const { getProductTypeGroups } = useProductTypeGroups();
const { checkAuth } = useCheckAuth();
const { handleDataChart } = useChart();
import { EVENT_POPUP } from '@/components/constants/constants';

export default {
  name: 'PerformanceComparePopup',
  mixins: [i18nMixin, widgetAddConfigMixin],
  emits: ['open-event-add-setting', 'close'],
  provide() {
    return {
      customChartStyle: {
        maxWidth: '1160px'
      },
      onInsightChartZoom: () => {
        this.onZoomChart();
      }
    };
  },
  components: {
    EventAddModal,
    InsightChart,
    SummaryChart,
    AddMonitorTargetDialog,
    LegoModalExtendV2,
    MonitoringTargetCommon,
    AddWidgetPopup,
    ScpmReloadDatePicker,
    PerformanceItem,
    NoData,
    AddMonitorTargetPopup
  },
  created() {
    this._pageInit();
  },
  mounted() {
    this.$refs['modal'].open();
    for (const EVENT in EVENT_POPUP)
      legoEventBus.$on(EVENT_POPUP[EVENT], (popupShow) =>
        this.setShowTooltipOfChart(EVENT, !popupShow)
      );
  },
  beforeUnmount() {
    for (const EVENT in EVENT_POPUP) legoEventBus.$off(EVENT);
  },
  watch: {
    selectedTargets: {
      deep: true,
      handler(v) {
        this.listChips = v.map((e) => {
          return {
            id: e.productResourceId || e.resourceId,
            label: e.productName,
            objectDisplayName: e.objectDisplayName,
            objectName: e.objectName,
            objectType: e.objectType
          };
        });
      }
    }
  },
  props: {
    selTarget: {
      type: Array,
      default: () => []
    },
    prodTypeCode: {
      type: String,
      default: ''
    }
  },
  computed: {
    conditionSubType() {
      const conditionSubType = new Map(PRODUCT_SUB_TYPE_OBJECT_NAME);
      return !(
        conditionSubType.get(this.searchModel.productTypeCode) === this.searchModel.subTypeCode
      );
    },
    // 하위항목 여부
    hasSubType() {
      return !!this.subTypes[this.searchModel.productTypeCode];
    },
    // 대시보드 view type
    isSummary() {
      return this.dashboardType == 'summary';
    },
    isKuber() {
      return this.searchModel.productTypeCode.toLowerCase() === 'kubernetes';
    },
    isCDN() {
      return this.searchModel.productTypeCode.toLowerCase() === 'cdn';
    },
    defaultInquiryPeriod() {
      return this.isCDN ? '7d' : '30m';
    },
    isNotChangeProduct() {
      return this.prevSearchModel.productTypeCode === this.searchModel.productTypeCode;
    },
    isK8sObjectType() {
      return this.isKuber && SUB_OBJECT_TYPES_WITH_K8S.includes(this.searchModel.subTypeCode);
    },
    showTooltipOfChart() {
      return Object.values(this.showTooltipOfChartList).every((showTooltip) => !!showTooltip);
    }
  },
  data() {
    return {
      eventAddShow: false,
      isResetTarget: false,
      searchDate: {},
      isCheckLoadData: false,
      listChips: [],
      searchCodes: {
        productTypeCodes: [],
        subTypeCodes: [],
        productTypeGroups: []
      },
      searchModel: {
        productTypeCode: this.prodTypeCode,
        subTypeCode: '',
        productTypeItem: {},
        subTypeItem: {}
      },
      prevSearchModel: {
        productTypeCode: '',
        subTypeCode: ''
      },
      subTypes: {
        Kubernetes: [],
        'Load Balancer': [],
        DataOps: [],
        DataFlow: [],
        QuickQuery: [],
        DataWrangler: []
      }, // 하위 항목

      selectedTargets: [], // 모니터링 대상
      beforeSelectedTargets: [],
      metricList: [], // 성능 항목 목록 tree 형태
      metricListOrg: [], // 성능 항목 목록
      selectedMetrics: [], // 선태한 성능항목

      customStyle: {
        body: {
          padding: '24px 0'
        }
      },

      dateOption: {
        startDate: '',
        endDate: '',
        formatter: '{HH}:{mm}',
        isNow: false // Whether query data is get to now or not ?
      }, // 검색 기간
      dashboardType: 'detail',

      popup: {
        addMonitorProps: {
          pProductTypeCode: '',
          pProductTypeName: '',
          pProductTypeCodes: [],
          pObjectTypeCode: ''
        },
        addTargetShow: false,
        addWidget: false,
        eventAddShow: false
      },
      selectedTargetAddSetting: {
        metric: null,
        targets: []
      },
      isAuthStatus: false,
      dataInsightChart: {
        // '': {
        //    chartKey: ''
        //    interval: '',
        //    statisticsTypeList: '',
        //    selectedIndividualItems: [],
        //    dataProps: {
        //    eventKey: '',
        //    eventName: '',
        //    data: [],
        //    }
        // }
      },
      dataSummaryChart: {},
      listIndividuals: {},
      collInterval: '1m',
      showTooltipOfChartList: {}
    };
  },
  methods: {
    setShowTooltipOfChart(key, value) {
      this.showTooltipOfChartList[key] = value;
    },
    async getCollectionInterval(productTypeCode) {
      this.collInterval = await this.$http.product.getCollectionInterval(productTypeCode);
    },
    isK8s(metric) {
      return this.isK8sObjectType && !this.disabledIndividualItem(metric);
    },
    getParamDownloadChart(item) {
      const selectedIndividuals = this.getSelectedIndividualInsightChart(item.metricKey);
      return {
        countSelectedObject: selectedIndividuals.length,
        countSelectedTargets: this.selectedTargets.length,
        productTypeCode: this.searchModel.productTypeCode,
        params: getParamChart({
          metric: item,
          isDownload: true,
          k8s: this.isK8s(item),
          hasSubType: this.hasSubType,
          objectType: this.listIndividuals[item.metricKey][0]?.objectType || 'pod',
          subTypeCode: this.searchModel.subTypeCode,
          selectedTargets: this.selectedTargets,
          listIndividuals: selectedIndividuals,
          startTime: this.dateOption.startDate,
          endTime: this.dateOption.endDate
        })
      };
    },
    setChartKey(key) {
      if (!key) return;
      this.dataInsightChart[key] = {
        ...this.dataInsightChart[key],
        chartKey: scpmUtil.generateRandomKey()
      };
    },
    setDataInsightChart(
      key,
      {
        interval,
        selectedIndividualItems,
        statisticsTypeList,
        dataProps = { eventName: '', eventKey: '', data: [] }
      }
    ) {
      if (!key) return;
      this.dataInsightChart[key] = {
        ...this.dataInsightChart[key],
        selectedIndividualItems,
        statisticsTypeList,
        interval,
        dataProps
      };
    },

    getSummaryOptions(metric) {
      const {
        displayUnit,
        metricName,
        metricUnit,
        fixedUnit,
        productTargetType,
        productTargetTypeEn,
        metricDescription,
        metricDescriptionEn
      } = metric;
      return {
        displayUnit,
        metricName,
        metricUnit,
        fixedUnit,
        productTargetType,
        productTargetTypeEn,
        metricDescription,
        metricDescriptionEn,
        productType: this.searchModel.productTypeCode
      };
    },
    getSelectedIndividualInsightChart(key) {
      if (!key) return;
      return this.dataInsightChart[key].selectedIndividualItems || [];
    },
    setSelectedIndividualItemInsightChart(key, data) {
      if (!key) return;
      this.dataInsightChart[key] = {
        ...this.dataInsightChart[key],
        selectedIndividualItems: data
      };
    },
    setDefaultInsightChartItem(key) {
      if (!key) return;
      const { statisticsTypeList, interval } = getDefaultMetricPayload(
        this.searchModel.productTypeCode,
        this.dateOption.startDate,
        this.dateOption.endDate,
        this.collInterval
      );
      this.dataInsightChart[key] = {
        interval,
        statisticsTypeList,
        selectedIndividualItems: [],
        chartKey: '',
        dataProps: { eventName: '', eventKey: '', data: [] }
      };
    },

    setDefaultSummaryChartItem(key) {
      if (!key) return;
      this.dataSummaryChart[key] = [];
    },

    onZoomChart() {
      this.$nextTick(() => {
        if (this.$refs.reloadPicker) {
          this.$refs.reloadPicker.onPause(() => {
            this.$toast.open(this.$t('label.descDisableInqueryTime'));
          });
        }
      });
    },
    async onChangeOfInsightChart(event, metricItem) {
      const {
        eventKey,
        eventName,
        query: { startTime, endTime, individualItems, interval, statisticalType }
      } = event;
      this.listIndividuals[metricItem.metricKey] = this.listIndividuals[metricItem.metricKey]?.map(
        (item) => ({
          ...item,
          isSelected: individualItems.includes(item.value)
        })
      );
      await this.getDataInsightChart(metricItem, {
        selectedIndividualItems: [...individualItems],
        statisticsTypeList: statisticalType,
        interval,
        eventName,
        eventKey,
        startTime: moment(startTime),
        endTime: moment(endTime)
      });
    },
    disabledIndividualItem(item) {
      if (!item.isObjectExist || item.isObjectExist === 'N') return true;
      return item.isObjectExist === 'Y' && item.disableObject === 'Y';
    },
    async _pageInit() {
      await this._getProductTypeCodes();
      this._setProductTypeItems(this.prodTypeCode);

      if (this.selTarget.length > 0) {
        this._setSubTypeItems(this.selTarget[0].objectTypeCode);
        this.selectedTargets = this.selTarget.map((item) => {
          return {
            productSq: item.productId,
            productName: item.productName,
            resourceId: item.productResourceId,
            productResourceId: item.productResourceId,
            objectTypeCode: item.objectTypeCode,
            objectName: item.objectName,
            objectType: item.objectType,
            objectDisplayName: item.objectDisplayName,
            idx: item.idx,
            check: item.check
          };
        });
        this.beforeSelectedTargets = this.$util.deepCopy(this.selectedTargets);
        await this._changeSelectedTartget();
      } else {
        this._setSubTypeItems();
        await this._getMetrics();
      }

      // 조회기간 설정
      this.$nextTick(() => {
        this.$refs.reloadPicker.datePickerRef.$refs.datepicker.setDate(
          this.defaultInquiryPeriod,
          () => {
            this.changeDateOption();
          }
        );
      });

      this.isAuthStatus = await this.checkProductSubTypeAuth(this.searchModel.productTypeCode);
    },

    async removeTarget(item) {
      if (!item) this.selectedTargets = [];
      else {
        this.selectedTargets = this.selectedTargets.filter(
          (e) =>
            !(
              item.id === e.resourceId &&
              item.objectName === e.objectName &&
              item.label === e.productName
            )
        );
      }

      await this._changeSelectedTartget();
      this.updateMonitorPops();
    },

    // 상품유형/서브유형 조회
    async _getProductTypeCodes() {
      await this.$http.product.getProductSubTypes('N').then(async (data) => {
        this.searchCodes.productTypeCodes = data;
        this.searchCodes.productTypeGroups = await getProductTypeGroups(data);
      });

      for (let productTypeCode in this.subTypes) {
        this.subTypes[productTypeCode] = await this.$http.product.getListProductObjectTypes(
          productTypeCode
        );
      }
    },

    // 상품유형 세팅
    _setProductTypeItems(productTypeCode) {
      this.searchModel.productTypeCode = productTypeCode;
      this.searchModel.productTypeItem = this.searchCodes.productTypeCodes.find(
        (item) => item.value == productTypeCode
      );

      this.prevSearchModel.productTypeCode = productTypeCode;

      let subTypeCodes = this.hasSubType ? this.subTypes[productTypeCode] : [];
      this.searchCodes.subTypeCodes = subTypeCodes;
      this.$refs.reloadPicker.resetReloadTime();
      this.getCollectionInterval(productTypeCode);
    },

    // 상품 하위유형 세팅
    _setSubTypeItems(subTypeCode) {
      let subTypeCodeItem = this.hasSubType
        ? subTypeCode
          ? this.searchCodes.subTypeCodes.find((item) => item.value == subTypeCode)
          : this.searchCodes.subTypeCodes[0]
        : {};

      this.searchModel.subTypeCode = subTypeCodeItem.value;
      this.searchModel.subTypeItem = subTypeCodeItem;

      this.prevSearchModel.subTypeCode = subTypeCodeItem.value;
    },

    async checkProductSubTypeAuth(productTypeCode) {
      const authData = await this.$store.dispatch('authStore/checkProductSubTypeAuthorization', {
        productTypeCode
      });
      if (!authData) return false;
      return authData.type === this.$const.AuthorizationResult.ALLOW;
    },

    async onChangeProductTypeCode(value) {
      this.isResetTarget = false;
      if (this.prevSearchModel.productTypeCode == value) return;
      this.searchModel.productTypeCode = value;
      const isPass = await this.checkProductSubTypeAuth(value);

      if (!isPass) {
        this.searchModel.productTypeCode = this.prevSearchModel.productTypeCode;
        this.searchModel.subTypeCode = this.prevSearchModel.subTypeCode;
        return;
      }

      this.$modal.open({
        rootId: 'app',
        type: 'confirm',
        title: this.$t('title.notice'),
        message: `<div>` + this.$t('page.performance.productTypeChangeCheck') + `</div>`,
        action: () => {
          this.$refs.reloadPicker.datePickerRef.$refs.datepicker.setDate(
            this.defaultInquiryPeriod,
            async () => {
              await this.$nextTick();
              this.changeDateOption();
            }
          );
          this._setProductTypeItems(value);
          this._setSubTypeItems();
          this._resetData();
          this.updateMonitorPops();
          this.isAuthStatus = true;
        },
        cancel: () => {
          this.searchModel.productTypeCode = this.prevSearchModel.productTypeCode;
          this.searchModel.subTypeCode = this.prevSearchModel.subTypeCode;
        }
      });
    },

    onChangeSubTypeCode(value) {
      this.isResetTarget = false;
      if (this.prevSearchModel.subTypeCode == value) return;
      this.searchModel.subTypeCode = value;
      this.$modal.open({
        rootId: 'app',
        type: 'confirm',
        title: this.$t('title.notice'),
        message: `<div>` + this.$t('page.performance.productTypeChangeCheck') + `</div>`,
        action: () => {
          this.$refs.reloadPicker.datePickerRef.$refs.datepicker.setDate('30m', async () => {
            await this.$nextTick();
            this.changeDateOption();
          });
          this._setSubTypeItems(value);
          this._resetData();
          this.updateMonitorPops();
        },
        cancel: () => {
          this.searchModel.subTypeCode = this.prevSearchModel.subTypeCode;
        }
      });
    },

    async _getMetrics(isChangeService = true) {
      let params = {
        targetSqs: this.selectedTargets.map((item) => item.productSq),
        objectType: this.searchModel.subTypeCode || ''
      };

      if (isChangeService) {
        this.metricList = [];
        this.metricListOrg = [];
      }

      await this.$http.product
        .getProductMetric(params, this.searchModel.productTypeCode, true)
        .then((data) => {
          let _items = this._makeMetricsTree(
            data.filter((item) => item.metricType.toUpperCase() !== 'TEXT'),
            true
          );
          this.metricList = _items;
        })
        .catch((e) => {
          if (e && e.code == 'AccessDenied') {
            this.$alert(e);
          }
        });
    },

    _makeMetricsTree(metrics, first = false) {
      let _items = [];
      metrics.forEach((item) => {
        let _metricSetName = item.metricSetName;

        let _metricSet = _items.find((metric) => metric.metricKey == _metricSetName);

        if (_metricSet === undefined) {
          _items.push({
            metricKey: _metricSetName,
            metricName: _metricSetName,
            metricSetName: _metricSetName,
            children: [item]
          });
        } else {
          _metricSet.children.push(item);
        }

        if (first) this.metricListOrg.push(item);
      });

      return _items;
    },

    _getObjects(metric) {
      if (!this.selectedTargets.length) return false;

      const params = {
        metricKeyList: [metric.metricKey],
        productIdList: this.selectedTargets.map((item) => item.productSq),
        queryStartDt: this.dateOption.startDate,
        queryEndDt: this.dateOption.endDate
      };

      return this.$http.product
        .getProductObjects(params, this.searchModel.productTypeCode, true)
        .then((data) => {
          this.listIndividuals[metric.metricKey] = data.map((item) => ({
            ...item,
            value: item.objectName,
            key: item.objectName,
            text: item.objectDisplayName,
            isSelected: false
          }));

          return true;
        })
        .catch((e) => {
          if (e && e.code == 'AccessDenied') {
            this.$alert(e);
          }
          return false;
        });
    },

    async _getK8sObject(metric) {
      if (!this.selectedTargets.length) return false;

      const params = {
        productIdList: this.selectedTargets.map((e) => e.productSq),
        productObjectType: this.searchModel.subTypeCode,
        productSubName: this.selectedTargets.map((e) => e.objectName),
        queryStartDt: this.dateOption.startDate,
        queryEndDt: this.dateOption.endDate
      };

      const payload = {
        productTypeCode: this.searchModel.productTypeCode,
        params,
        listDataCheckAuth: this.selectedTargets.map((product) => {
          return {
            productResourceId: product.productSq,
            productName: product.productName
          };
        })
      };

      const response = await this.$store.dispatch('authStore/checkAuthorizationCluster', payload);
      if (response.type === this.$const.AuthorizationResult.ALLOW) {
        const data = response.responseData;
        this.listIndividuals[metric.metricKey] = data.map((item) => ({
          ...item,
          value: item.objectName,
          key: item.objectName,
          text: item.objectDisplayName,
          isSelected: false
        }));
        return true;
      }

      return false;
    },

    // Handle data for Summary Chart
    setDataSummaryChart(key, data) {
      if (!key) return;
      this.dataSummaryChart[key] = data;
    },

    getDataSummaryChart(
      metric,
      { selectedIndividualItems = [], statisticsTypeList, startTime, endTime }
    ) {
      const hasSelectedTarget = this.beforeSelectedTargets.length;
      const hasIndividual = this.listIndividuals[metric.metricKey]?.length;
      const selectedIndividualEmpty = hasIndividual && !selectedIndividualItems.length;

      if (selectedIndividualEmpty || !hasSelectedTarget) return;

      const params = getParamChart({
        metric,
        isDownload: false,
        k8s: this.isK8s(metric),
        hasSubType: this.hasSubType,
        objectType: this.listIndividuals[metric.metricKey][0]?.objectType || 'pod',
        subTypeCode: this.searchModel.subTypeCode,
        selectedTargets: this.beforeSelectedTargets,
        listIndividuals: this.listIndividuals[metric.metricKey].map(({ value }) => value) || [],
        startTime,
        endTime,
        statisticsTypeList,
        selectedIndividualItems
      });

      const { interval } = getDefaultMetricPayload(
        this.searchModel.productTypeCode,
        startTime,
        endTime,
        this.collInterval
      );
      const isCollectionValue = checkIsCollectionValue(
        interval,
        this.collInterval,
        this.searchModel.productTypeCode
      );

      return this.$http.product
        .getProductMetricData(params, this.searchModel.productTypeCode, true, true)
        .then((res) => {
          const rawData = res.map((item) => {
            const intervalTS = item.statisticsPeriod ?? '';
            item.perfData = handleDataChart(item.perfData, intervalTS, startTime, endTime);
            return item;
          });
          this.setDataSummaryChart(
            metric.metricKey,
            convertRawDataToDataChart({
              rawData,
              isCollectionValue,
              hasIndividual
            })
          );
          return true;
        })
        .catch((e) => {
          if (e && e.code == 'AccessDenied') {
            this.$alert(e);
          }
          return false;
        });
    },
    getInitDataSummaryChart(metric) {
      const { startDate: startTime, endDate: endTime } = this.dateOption;
      const { statisticsTypeList } = getDefaultMetricPayload(
        this.searchModel.productTypeCode,
        startTime,
        endTime,
        this.collInterval
      );
      const allIndividualItems =
        this.listIndividuals[metric.metricKey].map(({ value }) => value) || [];
      return this.getDataSummaryChart(metric, {
        statisticsTypeList,
        selectedIndividualItems: allIndividualItems,
        startTime,
        endTime
      });
    },
    getDataInsightChart(
      metric,
      {
        selectedIndividualItems = [],
        interval,
        statisticsTypeList,
        eventName = '',
        eventKey = '',
        startTime,
        endTime
      },
      callback
    ) {
      this.setSelectedIndividualItemInsightChart(metric.metricKey, selectedIndividualItems);
      const hasSelectedTarget = this.beforeSelectedTargets.length;
      const hasIndividual = this.listIndividuals[metric.metricKey]?.length;
      const selectedIndividualEmpty = hasIndividual && !selectedIndividualItems.length;
      const isEqualTime = moment(startTime).valueOf() === moment(endTime).valueOf();

      if (!hasSelectedTarget || selectedIndividualEmpty || isEqualTime) {
        this.setDataInsightChart(metric.metricKey, {
          selectedIndividualItems,
          statisticsTypeList,
          interval,
          dataProps: {
            eventName,
            eventKey,
            data: []
          }
        });
        callback && callback();
        return;
      }

      const payload = getParamChart({
        metric,
        isDownload: false,
        k8s: this.isK8s(metric),
        hasSubType: this.hasSubType,
        objectType: this.listIndividuals[metric.metricKey][0]?.objectType || 'pod',
        subTypeCode: this.searchModel.subTypeCode,
        selectedTargets: this.beforeSelectedTargets,
        listIndividuals: this.listIndividuals[metric.metricKey].map(({ value }) => value) || [],
        startTime,
        endTime,
        statisticsTypeList,
        selectedIndividualItems
      });

      return this.$http.product
        .getProductMetricData(
          { ...payload, interval },
          this.searchModel.productTypeCode,
          true,
          true
        )
        .then((res) => {
          const isCollectionValue = checkIsCollectionValue(
            interval,
            this.collInterval,
            this.searchModel.productTypeCode
          );
          // handle data of chart
          const rawData = res.map((item) => {
            item.perfData = handleDataChart(item.perfData, interval, startTime, endTime, false);
            return item;
          });
          this.setDataInsightChart(metric.metricKey, {
            selectedIndividualItems,
            statisticsTypeList,
            interval,
            dataProps: {
              eventName,
              eventKey,
              data: convertRawDataToDataChart({
                rawData,
                isCollectionValue,
                hasIndividual
              })
            }
          });
          callback();
          return true;
        })
        .catch((e) => {
          if (e && e.code == 'AccessDenied') {
            this.$alert(e);
          }
          return false;
        });
    },
    getInitDataInsightChart(metric, callback) {
      const startTime = this.dateOption.startDate;
      const endTime = this.dateOption.endDate;
      const { statisticsTypeList, interval } = getDefaultMetricPayload(
        this.searchModel.productTypeCode,
        startTime,
        endTime,
        this.collInterval
      );

      const beforeSelectedIndivItems = this.getSelectedIndividualInsightChart(metric.metricKey);
      const indivs = this.listIndividuals[metric.metricKey] || [];

      const newSelectedIndivItems = beforeSelectedIndivItems.filter((value) =>
        indivs.some((item) => item.value === value)
      );
      this.setSelectedIndividualItemInsightChart(metric.metricKey, newSelectedIndivItems);

      this.listIndividuals[metric.metricKey] = this.listIndividuals[metric.metricKey]?.map(
        (item) => ({
          ...item,
          isSelected: newSelectedIndivItems.includes(item.value)
        })
      );

      return this.getDataInsightChart(
        metric,
        {
          selectedIndividualItems: newSelectedIndivItems,
          statisticsTypeList,
          interval,
          startTime,
          endTime
        },
        callback
      );
    },
    resetDataChart() {
      for (const metric of this.selectedMetrics) {
        this.listIndividuals[metric.metricKey] = [];
        this.setDefaultInsightChartItem(metric.metricKey);
        this.setDefaultSummaryChartItem(metric.metricKey);
        this.setChartKey(metric.metricKey);
      }
    },
    async _resetData() {
      this.selectedTargets = [];
      this.selectedMetrics = [];
      this.beforeSelectedTargets = [];
      this.isResetTarget = true;
      this.dataInsightChart = {};
      this.dataSummaryChart = {};
      this.listIndividuals = [];
      this.metricList = [];
      this.metricListOrg = [];
      await this._changeSelectedTartget();
    },

    async _changeSelectedTartget() {
      await this._getMetrics(false);
      let _selectedMetrics = this.selectedMetrics.filter((_metric) => {
        return (
          this.metricListOrg.findIndex((item) => {
            return item.metricKey == _metric.metricKey;
          }) > -1
        );
      });

      this.selectedMetrics = _selectedMetrics;
      this.beforeSelectedTargets = this.$util.deepCopy(this.selectedTargets);
      await this.handleReloadDataInsightChart();
    },

    // 성능 항목 선택 여부 체크
    checkSelectMetric(itemName) {
      return !!this.selectedMetrics.find((d) => d.metricName == itemName);
    },

    async addMetricItem(metric) {
      const metricIndex = this.selectedMetrics.findIndex((m) => m.metricKey === metric.metricKey);
      if (metricIndex > -1) {
        return this.delMetricItem(metricIndex);
      }

      this.listIndividuals[metric.metricKey] = [];
      this.setDefaultInsightChartItem(metric.metricKey);

      if (metric.isObjectExist == 'Y' && !this.hasSubType) {
        await this._getObjects(metric);
      }
      if (this.isK8sObjectType && !this.disabledIndividualItem(metric)) {
        await this._getK8sObject(metric);
      }
      // Get original data for  data insight chart
      this.getInitDataInsightChart(metric);
      //get original data for data summary chart
      this.getInitDataSummaryChart(metric);
      this.selectedMetrics.push(metric);
      this._scrollEnd();
    },
    delMetricItem(idx) {
      this.selectedMetrics.splice(idx, 1);
    },
    changeDateOption() {
      const datePicker = this.$refs.reloadPicker.getCurrentDate();
      this.searchDate = datePicker;
      let _formatter = (value) => this._getDateFormat(value);
      this.dateOption = {
        startDate: datePicker.queryStartDt,
        endDate: datePicker.queryEndDt,
        formatter: _formatter,
        isNow: datePicker.isNow || false
      };
    },
    _getDateFormat(value) {
      const DAY = 24 * 60 * 60 * 1000;
      const datePicker = this.$refs.reloadPicker.getCurrentDate();
      let period = new Date(datePicker.queryEndDt) - new Date(datePicker.queryStartDt);
      let format = moment(value).format('HH:mm');
      if (period > DAY) {
        format = moment(value).format('MM-DD HH').split('');
        format[5] = '\n';
        format = format.join('') + 'h';
      }
      return format;
    },

    async handleReloadDataInsightChart() {
      if (!this.selectedTargets.length) {
        this.resetDataChart();
      }

      for (const metric of this.selectedMetrics) {
        if (metric.isObjectExist == 'Y' && !this.hasSubType) {
          await this._getObjects(metric);
        }
        if (this.isK8s(metric)) {
          await this._getK8sObject(metric);
        }
        this.getInitDataInsightChart(metric, () => this.setChartKey(metric.metricKey));
        this.getInitDataSummaryChart(metric);
      }
    },

    // 기간 설정 팝업 확인
    async onRefresh() {
      if (this.isCDN && this.checkTimeSearch()) return;
      this.changeDateOption();
      this.handleReloadDataInsightChart();
    },

    checkTimeSearch() {
      const datePicker = this.$refs.reloadPicker.getCurrentDate() || {};
      const { queryStartDt, queryEndDt } = datePicker;
      if (!queryStartDt || !queryEndDt) return;
      const currentDate = moment().valueOf();
      const startDate = moment(queryStartDt).valueOf();
      const timeStampOfOneDay = 24 * 60 * 60 * 1000;
      if (startDate > currentDate - timeStampOfOneDay) {
        this.$alert(this.$t('label.cdnGuide'));
        this.$refs.reloadPicker.setRefreshInterval(this.searchDate.refreshInterval || '1');
        if (this.searchDate.dateType === 1) {
          this.$refs.reloadPicker.datePickerRef.$refs.datepicker.setDate(
            this.searchDate.tab1value,
            () => {},
            true
          );
        } else {
          this.$refs.reloadPicker.datePickerRef.$refs.datepicker.setDate(
            this.searchDate,
            () => {},
            true
          );
        }
        this.$refs.reloadPicker.showNow();
        return true;
      }
      return false;
    },

    // 모니터링 대상 추가 팝업보기
    async showAddTargetDialog() {
      await this.$http.product
        .getSummaries({}, this.searchModel.productTypeCode, true)
        .then(() => {
          this.updateMonitorPops();
        })
        .catch((e) => {
          if (e && e.code == 'AccessDenied') {
            this.$alert(e);
          }
        });
      this.isCheckLoadData = true;
    },

    confirmDialog() {
      this.isCheckLoadData = false;
      this._changeSelectedTartget();
    },
    closeDialog() {
      this.selectedTargets = this.$util.deepCopy(this.beforeSelectedTargets);
    },
    chooseItems(value) {
      this.selectedTargets = [...value];
    },

    /*********************  위젯 추가 시작 *********************/
    // 위젯 추가 팝업
    addWidgetPopup(metric, chartType) {
      const listId = this.getSelectedIndividualInsightChart(metric.metricKey);
      const listIndivs = this.listIndividuals[metric.metricKey].filter((item) =>
        listId.includes(item.value)
      );
      let objectItems = [];
      let products = this.$util.replaceArr(this.selectedTargets, {
        productName: 'text',
        resourceId: 'key',
        productSq: 'productSq',
        idx: 'idx',
        check: 'check'
      });

      if (this.hasSubType && this.conditionSubType) {
        // 하위 상품유형이 있으면 ( k8s, lb )
        objectItems = this.$util.replaceArr(this.selectedTargets, {
          objectName: 'key',
          objectDisplayName: 'text',
          resourceId: 'productResourceId',
          idx: 'idx',
          check: 'check'
        });
        products = _.uniqBy(products, 'key');
      }
      let config = {
        chartAttr: {
          widget: {
            type: 'TimeSeriesGraphWidget', // 위젯 종류 : 시계열 위젯
            options: {
              chartType: chartType, // 차트 종류 (line, stack, scatter...)
              isObjectExist: metric.isObjectExist, // 개별항목 존재 여부
              disableObject: metric.disableObject,
              metricName: metric.metricName,
              metricKey: metric.metricKey, // metricKey
              objectItems: objectItems, // 하위 모니터링 대상
              objectType: this.searchModel.subTypeCode || null, // 하위 상품 유형
              objects: listIndivs, // 개별항목
              products: products, // 모니터링 대상
              resourceType: this.searchModel.productTypeCode // 상품유형
            }
          }
        }
      };
      this.widgetConfig = config;
      this.togglePopup('addWidget');
    },

    // 스크롤 이동
    _scrollEnd() {
      this.$nextTick(() => {
        const scrollElement = this.$refs.cscroll.$refs.scrollElement;
        scrollElement.scrollTop = scrollElement.scrollHeight;
      });
    },

    // 팝업 토글
    togglePopup(id) {
      if (id === 'eventAddShow') this.resetDataAddSetting();
      this.popup[id] = !this.popup[id];
    },

    // 성능 비교 팝업 닫기
    onClosed() {
      this.$emit('close');
    },
    //조회기간 탭 정보
    isDatePickerButtonTab() {
      return this.$refs.reloadPicker.getCurrentDate().dateType === 1;
    },
    isActiveWidget() {
      return !this.$http.getRoleId();
    },
    onSelectedMetric(metric) {
      legoEventBus.$emit('click-outside');
      this.addMetricItem(metric);
    },
    eventAddModal(item) {
      const productResourceIds = [];
      const listDataCheckAuth = [];
      this.resetDataAddSetting();
      this.selectedTargetAddSetting.metric = item;
      if (this.selectedTargets.length) {
        this.selectedTargets.forEach((value) => {
          if (value.productResourceId) {
            productResourceIds.push(value.productResourceId);
            listDataCheckAuth.push({
              productResourceId: value.productResourceId,
              productName: value.productName
            });
          }
        });
        const productTypeCode = item && item.productTypeCode;
        const callback = (data) => {
          if (data.type === this.$const.AuthorizationResult.ALLOW) {
            this.selectedTargets.forEach((value) => {
              this.selectedTargetAddSetting.targets.push({
                ...value,
                productSq: value.productSq ?? value.productId,
                label: value.productName,
                value: value.productName
              });
            });
            this.popup.eventAddShow = true;
          }
        };
        const errorCallback = (err) => {
          this.$alert(err);
        };
        checkAuth(
          {
            productTypeCode,
            productResourceIds,
            listDataCheckAuth,
            actionName: this.$const.AuthorizationAction.MONITOR_VIEW
          },
          callback,
          errorCallback
        );
      } else {
        this.popup.eventAddShow = true;
      }
    },
    resetDataAddSetting() {
      this.selectedTargetAddSetting = {
        metric: null,
        targets: []
      };
    },
    updateMonitorPops() {
      this.popup.addMonitorProps.pProductTypeName =
        this.searchModel.productTypeItem.productTypeName;
      this.popup.addMonitorProps.pProductTypeCode = this.searchModel.productTypeCode;
      this.popup.addMonitorProps.pObjectTypeCode = this.searchModel.subTypeCode;
      this.popup.addMonitorProps.pProductTypeCodes = this.selectedTargets;
    }
  }
};
</script>

<style lang="scss" scoped>
.container-performace-compare {
  display: flex;
  flex-direction: column;
  height: 100%;

  .container-comp {
    display: flex;
    height: 100%;
    max-height: 100%;
    overflow: auto;

    &__left {
      width: 328px;
      min-width: 328px;
      border-right: 1px solid #d2d3d6;
    }

    &__right {
      padding-left: 24px;
      display: flex;
      flex-direction: column;
      gap: 16px;
      width: 100%;

      &-filter {
        display: flex;
        justify-content: space-between;

        .view-mode {
          :deep(.lego-segment-button--medium) {
            min-width: 32px !important;
            width: 32px !important;
          }
        }
      }

      &-graph {
        height: 100%;
        max-height: 100%;
        overflow: auto;
      }

      :deep .range-wrap {
        right: -8px !important;
        border-radius: 4px;
      }
    }
  }

  .box-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    padding: 16px 16px 0px;

    .button-width {
      width: 100%;
    }

    & .right-con {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      :deep .chart-container {
        .con-right {
          height: auto;
        }
      }
    }

    & .dropdown-group {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin: 0;
      gap: 12px;

      .object-check {
        width: 180px !important;
      }
    }
  }

  .perform-stitle {
    float: left;
    display: flex;
    // max-width: 260px;
    max-width: 390px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}

:deep .accordion-check .lego-icon > svg > path {
  fill: var(--blue-with-a-hint-of-purple);
}

:deep .object-check .summary {
  width: 100% !important;
  height: 28px;
  margin-bottom: 0px;
}

:deep .lego-segment-wrapper {
  margin-right: 8px;
}

:deep .nmx-inquiry-period {
  & > .lego-button {
    width: 180px !important;
    justify-content: left;

    & .lego-button__icon {
      display: none;
    }
  }
}

:deep .lego-dashboard {
  border: 0 !important;
  min-height: unset;
}

:deep .lego-dashboard-item {
  display: flex;
  flex-direction: column;
  height: 373px;
  background-color: #fff;
  //border-radius: 4px;
  margin-bottom: 8px;
  &:nth-child(4n + 4),
  &:nth-child(4n + 3) {
    &:not(.detail-chart) {
      .tooltip-wrapper .tooltip-icon .tooltip-container {
        left: auto;
        right: 22px;
      }
    }
  }
  .box-header {
    margin: 0px;
  }
}

:deep .added-list-box .box-title {
  span,
  .total-value:before {
    display: none !important;
  }
}

:deep .check-search-box .lego-text-field {
  min-width: 160px;
}

:deep .echarts {
  z-index: 0;
}

:deep .hidden-ghost {
  display: none !important;
}

:deep .listTargetItem {
  display: inline-block;
  color: #364fc7;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

:deep .widget-null {
  width: auto !important;
  min-height: 0 !important;
  margin: 0 auto !important;
  padding: 20px 0 !important;
}
.chart-guide {
  float: right;
  padding-left: 20px;
  line-height: 16px;
  font-size: 13px;
  color: #555b68;
  display: flex;
  gap: 8px;
  max-width: 500px;
}
</style>
